import { render } from "./themes-categories.vue?vue&type=template&id=5b284e40"
import script from "./themes-categories.vue?vue&type=script&lang=js"
export * from "./themes-categories.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__